<template>
	<div>
		<div v-for="(year, index) in tableData" :key="index">
			<span tabindex="0">
				<i :key="`Progress-${index}`" v-if="year.IN_PROGRESS" style="display: inherit;">
					{{ $t( 'MAIN_CONTENT.ProgressReportDepartments.inProgress' ) }} <br />
				</i>
				<strong>
					{{ $t('MAIN_CONTENT.ProgressReportYears.schoolYearWithColon', { year: year.SCHOOL_YEAR } ) }}
				</strong>
			</span>
			<div class="table-responsive">
				<template v-if="!year.IN_PROGRESS">
					<table-editable-list :columns="yearColumnsConfig"
																:show-select="false"
																:show-actions="false">
						<template slot="data-row">
							<table-list-row :columns="yearColumnsConfig"
															:rowdata="course"
															:rowIndex="courseIdx"
															:showActions="false"
															v-for="(course, courseIdx) in year.COURSES"
															:key="`courseData_${course.COURSE_ID}_${courseIdx}`">
							</table-list-row>
						</template>
					</table-editable-list>
				</template>
				<template v-else>
					<table-editable-list :columns="yearColumnsConfig"
																:show-select="false"
																:show-actions="false"
																v-if="year.IN_PROGRESS">
						<template slot="data-row">
							<table-list-row :columns="yearColumnsConfig"
															:rowdata="course"
															:rowIndex="courseIdx"
															:showActions="false"
															v-for="(course, courseIdx) in year.COURSES"
															:key="`courseData_${course.COURSE_ID}_${courseIdx}`">
							</table-list-row>
						</template>
					</table-editable-list>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		name: 'ProgressReportYears',
		props: {
			yearColumnsConfig: {
				type: Array,
				required: true
			},
			tableData: {
				type: Array,
				required: true
			}
		},
		components: {
			TableEditableList,
			TableListRow
		}
	}
</script>
